import React, { MouseEventHandler } from 'react';
import { translate } from '@fiverr-private/i18n-react';
import { TimesButton } from '@fiverr-private/button';
import type { AttachmentProps } from '../types';

const RemoveButton = ({
  onClick,
  variant,
  theme,
}: {
  onClick?: MouseEventHandler<HTMLButtonElement>;
  variant: AttachmentProps['variant'];
  theme: AttachmentProps['theme'];
}) => {
  if (!onClick) return null;

  const isDark = theme === 'dark';

  return (
    <TimesButton
      onClick={onClick}
      ariaLabel={translate<string>('attachments.remove')}
      size={variant === 'list' ? 'sm' : 'xs'}
      theme={theme === 'dark' ? 'light' : 'dark'}
      variant={variant === 'list' || isDark ? 'ghost' : 'filled'}
    />
  );
};

RemoveButton.displayName = 'RemoveButton';
export default RemoveButton;
